import { DatePipe } from "@angular/common";
import {
        Component,
        EventEmitter,
        Input,
        OnInit,
        Output,
        ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { DCService } from "../../../services/index";

@Component({
  selector: "scrap-bit-dc",
  templateUrl: "./scrapBitPrint.html",
})
export class scrapBitPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  
  printdata: any = {};
  dataList: any = [];
  woDetails: any;
  alphabet: string[];
  predefCol: number;
  userDefCol: number;
  dcList : any = [];
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    console.log(this.printdata);
    this.getDesignList(this.printdata.scrap_out_id);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    private dcService: DCService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(id) {
    const params = {
      scrap_out_id: id,
    };
    let that = this;
    that.dcService.dcScrapBitDesignList(params).then((res: any) => {
      that.dcList = (res.data)?res.data:[];
      for (let i = 0; i < that.dcList.length; i++) {
        that.dcList[i].lump_no = that.dcList[i].lump_no
          .toString()
          .padStart(6, "0");
      }
    });
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/scrapBit/scrapBitPrint.ts